require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./interviste-alberto-finzi.json") })
        }
      }, "path---interviste-alberto-finzi");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---interviste-alberto-finzi!./.cache/json/interviste-alberto-finzi.json
// module id = 669
// module chunks = 231608221292675